import { trackEvent } from 'util/trackingHelper';

export const trackCardCustomizationStarted = (
  type: string,
  uuid: string,
  projectTrackedEvents: any = [], // eslint-disable-line
  activeMediumKey: string,
  activeSelectionSize: string
): void => {
  const shouldTrackEvent =
    projectTrackedEvents.filter((event: { name: string }) => event.name === 'Customization Started')
      .length === 0;

  if (shouldTrackEvent) {
    trackEvent('Customization Started', {
      customization_type: type,
      customization_medium: activeMediumKey,
      customization_size: activeSelectionSize,
      card_project_customization_id: uuid,
    });
  }
};
